// 在项目最开始的地方引入下面的代码
import browserClient from '@apmplus/web'; // 配置参数
import { REGION_MODE, ENV_MODE } from './config';

export function apmStatics() {
  console.log('apm', `${REGION_MODE}-${ENV_MODE}`);
  // 生产环境开启上报
  if (process.env.NODE_ENV === 'development') return;

  browserClient('init', {
    aid: 595718, // 应用唯一标识，必填参数
    token: '2a147c5ed2bd46c8ae9a122877dfd912', // 应用 token,必填参数
    release: '1.0.3', // 必须与上传SourceMap时一致
    env: `${REGION_MODE}-${ENV_MODE}`,
    plugins: {
      pageview: {
        routeMode: "history"
      },
      blankScreen: true
    }
  });
  // 开启上报
  browserClient('start');
  return browserClient;
}
